'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:LoginCustomerCtrl
 * @description
 * # LoginCustomerCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('LoginCustomerCtrl', function ($scope, api) {
		$scope.customer = {email:''};

		$scope.requestLoginLink = function () {
			api.requestLoginLink($scope.customer.email).then(function () {
				toastr.success('A login link has been sent to ' + $scope.customer.email + '. Please check your inbox.', 'Email Sent');
			});
		};
	});
